var _path, _path2, _path3, _path4, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 271,
    viewBox: "0 0 208 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.574 33.1201V270.37H171.324H175.164H207.874V237.65V33.1201H38.574Z",
    fill: "#080E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.014 25.5601V262.81H163.764H167.604H200.314V230.09V25.5601H31.014Z",
    fill: "#6CCA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.454 18.0001V255.25H156.204H160.044H192.754V222.53V18.0001H23.454Z",
    fill: "#E8FFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.879 100.533L107.856 100.534L107.834 100.537C107.684 100.557 107.537 100.596 107.396 100.654L72.6915 112.684C72.0016 112.923 71.538 113.57 71.5325 114.299H71.5325V114.303C71.5325 137.113 75.8434 151.182 82.5659 160.781L82.9488 160.512L82.5659 160.781C89.2739 170.357 98.2657 175.29 107.111 180.142L107.156 180.166L107.156 180.166C107.672 180.449 108.296 180.449 108.813 180.167L108.813 180.166L108.912 180.112C117.739 175.27 126.732 170.338 133.434 160.781C140.165 151.183 144.468 137.114 144.468 114.303L144.468 114.299C144.462 113.57 143.997 112.923 143.308 112.685C143.308 112.685 143.308 112.685 143.308 112.685L108.57 100.653C108.352 100.567 108.117 100.525 107.879 100.533ZM107.381 179.756C107.757 179.963 108.212 179.963 108.588 179.756L108.655 179.72C117.501 174.867 126.411 169.98 133.051 160.512C139.707 151.021 144 137.059 144 114.303C143.996 113.772 143.657 113.3 143.155 113.127L107.381 179.756ZM130.586 158.795L130.969 159.064L130.586 158.795C124.567 167.378 116.546 172.014 107.984 176.718C99.4226 172.014 91.3943 167.377 85.3831 158.795C79.302 150.114 75.1924 137.118 75.0333 115.509L107.985 104.089L140.966 115.51C140.807 137.117 136.674 150.114 130.586 158.795Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.935065
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5641,
    cy: 43.5512,
    r: 34.4359,
    fill: "#BADEAC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4615,
    cy: 36.4615,
    r: 34.7253,
    fill: "#6CCA36",
    stroke: "black",
    strokeWidth: 3.47253
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.8fabd96e00270cf0c5635bed89729ebc.svg";
export { ForwardRef as ReactComponent };